import { getRscObject } from "helpers/rsc"

export const isHeats = (rsc)  => {
   const {event, phase} = getRscObject(rsc);
   return phase.includes("HEAT") && (event.includes("C1--") || event.includes("K1--"));
}

export const isFinals = (rsc)  => {
    const {event, phase} = getRscObject(rsc);
    return !phase.includes("HEAT") && (event.includes("C1--") || event.includes("K1--"));
}

export const isExtremeQualification = (rsc)  => {
    const {event, phase} = getRscObject(rsc);
    return phase.includes("QUAL") && event.includes("X1--");
}

export const isNotExtremeQualification = (rsc)  => {
    const {event, phase} = getRscObject(rsc);
    return !phase.includes("QUAL") && event.includes("X1--");
}

export const isSemis = (rsc)  => {
    const {phase} = getRscObject(rsc);
    return phase.includes("SFNL");
}

export const isTeam = (rsc)  => {
    const {event} = getRscObject(rsc);
    return event.includes("TEAM3");
}